import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlogCreatePage } from './blog-create.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'blog/create',
    component: BlogCreatePage,
    canActivate: [authGuard, hasRoleGuard(null, ['create_blog'])],
    data: {
      title: "Nueva entrada al blog."
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogCreatePageRoutingModule { }
